/**
 * What the resolver needs to know about the world, and the shape of an issue
 * as seen by the in-memory predicate. Both the server (from its in-process
 * cache) and the browser (from its normalized store) implement `Schema`.
 */
/** Kinds whose values are ids into a bundle (or the users / groups tables). */
export const ID_KINDS = new Set([
    "enum",
    "state",
    "user",
    "group",
    "version",
    "build",
    "owned",
]);
export const NUMBER_KINDS = new Set(["period", "integer", "float"]);
export const DATE_KINDS = new Set(["date", "datetime"]);
export const STRING_KINDS = new Set(["string", "text"]);
export function fieldKey(fieldId) {
    return `f_${fieldId}`;
}
//# sourceMappingURL=schema.js.map